import { component } from 'picoapp'

export default component((node,ctx) => {
    const { template, url, title } = node.dataset
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'
    
    // We look for a brand that has the current URL as one of its keys' values,
    // because the match will have `link_url_${gender}` === url
    const matchingBrand = window.theme.brands.find(brand => Object.keys(brand).find(key => brand[key] === url));
    if (matchingBrand) insertBrandLogo()

    function insertBrandLogo() {
        node.innerHTML =    `
                            <img src="${matchingBrand[`logo_${template}`]}" alt="${matchingBrand.vendor_name}"></img>
                            <span style="display: none;">${title}</span>
                            `
    }
})